<template>
  <v-container
    fluid
    class="pa-0 login-background"
    :style="{ backgroundImage: 'url(' + $cdnEndpoint + 'img/login/login_background.jpg)' }"
    style="text-align: center"
  >
    <v-layout align-center column justify-center class="bg-color-white login-form-area">
      <WarningText
        :is-show="!isChromeAccess"
        warning-text="動作推奨ブラウザは「Google Chrome(グーグル クローム)」最新版です。ブラウザを切り替えてご利用ください。"
      />
      <v-flex class="mt-5 mb-5">
        <Button :width="313" :height="40" primary @click.native="submitLogin()">ログイン</Button>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// API
import WarningText from '@/components/_atoms/WarningText.vue';
import Button from '@/components/_atoms/buttons/Button.vue';
import AuthClient from '@/utils/auth';

export default {
  name: 'Login',
  props: {
    errorMessage: {
      type: String,
      required: false
    }
  },
  mounted() {
    if (this.errorMessage) {
      this.$store.dispatch('message/setErrorMessage', {
        message: this.errorMessage
      });
    }
  },
  components: {
    WarningText,
    Button
  },
  data() {
    return {};
  },
  computed: {
    isChromeAccess() {
      return this.$store.getters['userAgent/getIsChromeAccess'];
    }
  },
  methods: {
    submitLogin() {
      AuthClient.login();
    }
  }
};
</script>

<style scoped>
.v-toolbar {
  display: none;
}
/* Form */
.login-form-area {
  position: absolute;
  top: calc(50% - 50px);
  left: 50%;
  transform: translate(-50%, -50%);
  width: 426px;
  border-radius: 5px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cfccc3;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}
.v-alert.v-alert {
  border: none !important;
  margin-bottom: 25px;
}

.login-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
}
</style>
